export default __webpack_public_path__ + "static/media/photo--lg--86.b88698fb.jpg";